// extracted by mini-css-extract-plugin
export default {"projectsPage":"ProjectsPage_projectsPage__1TBy+","projectsGrid":"ProjectsPage_projectsGrid__SqnuV"};